module.exports = __webpack_public_path__ + "static/media/simpledb-heuristicplanner.b19a4120.png";